import { render, staticRenderFns } from "./CallsTimeStatBlock.vue?vue&type=template&id=416c147f&scoped=true&"
import script from "./CallsTimeStatBlock.vue?vue&type=script&lang=js&"
export * from "./CallsTimeStatBlock.vue?vue&type=script&lang=js&"
import style0 from "./CallsTimeStatBlock.vue?vue&type=style&index=0&id=416c147f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416c147f",
  null
  
)

export default component.exports